import { createEvent, createStore } from 'effector';

export interface ToastMessage {
  id: number;
  message: string;
  tone: 'neutral' | 'error';
  action?: { label: string; onAction: () => void };
}

let nextId = 1;

export const toastShown = createEvent<Omit<ToastMessage, 'id'>>();
export const toastClosed = createEvent<number>();

export const $toasts = createStore<ToastMessage[]>([])
  .on(toastShown, (list, toast) => [...list.slice(-2), { ...toast, id: nextId++ }])
  .on(toastClosed, (list, id) => list.filter((t) => t.id !== id));
